var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bs-docs-nav",
    attrs: {
      "id": "top"
    }
  }, [_c('n3-container', {
    staticStyle: {
      "width": "92%"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('n3-nav', {
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('n3-nav-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "./index.html"
    }
  }, [_vm._v("N3")])]), _vm._v(" "), _c('n3-nav-item', {
    attrs: {
      "index": "2"
    }
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "./component_en.html"
    }
  }, [_vm._v("中文")])])], 1)], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-73f23b02", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73f23b02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example_zh/headerDocs.vue
// module id = 912
// module chunks = 0